var _effectorFileName = "/builds/gmini/front-ui-kit/src/DialogContentText/DialogContentText.styled.ts";
import styled from 'styled-components';
import { Typography } from '../Typography';
export const DialogContentTextWrapper = styled(Typography)`
  margin-bottom: 12px;
`;